<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSupportAgent_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <mask
        id="IconSupportAgent_24__a"
        width="24"
        height="24"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style="mask-type: alpha"
    >
        <path fill="currentColor" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#IconSupportAgent_24__a)">
        <path
            fill="currentColor"
            d="M11 21v-2h8v-7.1q0-2.925-2.038-4.962T12 4.9 7.038 6.937 5 11.9V18H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 16v-2q0-.525.263-.988.262-.462.737-.737l.075-1.325a8.7 8.7 0 0 1 .987-3.15 9.5 9.5 0 0 1 1.975-2.525A8.8 8.8 0 0 1 8.763 3.6Q10.3 3 12 3t3.225.6 2.725 1.663a9 9 0 0 1 1.975 2.512q.775 1.45 1 3.15l.075 1.3q.475.225.738.675.262.45.262.95v2.3q0 .5-.262.95t-.738.675V19q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21z"
        />
    </g>
</svg>
